import { render, staticRenderFns } from "./Setter.vue?vue&type=template&id=187b828f&scoped=true&"
import script from "./Setter.vue?vue&type=script&lang=js&"
export * from "./Setter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b828f",
  null
  
)

export default component.exports